"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    orientation: {
        type: String,
        default: undefined
    },
    panes: {
        type: Array,
        default: undefined
    },

    // Events
    collapse: Function,
    contentLoad: {
        type: Function,
        default: undefined
    },
    error: Function,
    expand: Function,
    layoutChange: {
        type: Function,
        default: undefined
    },
    resize: Function
};